import { Discard } from './Discard';
import { FollowUp } from './FollowUp';
import { DocumentHighlights } from './Highlights';
import { PlaybookReference } from './PlaybookReference';
import { Recover } from './Recover';
import { Container, Spacer } from './styled';
export function Actions(props) {
    const { feedback, getHighlights } = props;
    return (<Container>
      <Spacer>
        <FollowUp feedbackId={feedback.feedback.id}/>
        {feedback.feedback.discarded ? (<Recover feedbackId={feedback.feedback.id}/>) : (<Discard feedbackId={feedback.feedback.id}/>)}
      </Spacer>
      <Spacer>
        <DocumentHighlights getHighlights={() => getHighlights()}/>
        <PlaybookReference playbookRules={feedback.playbookRules}/>
      </Spacer>
    </Container>);
}
